// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"83d459ca","185":"129acd6b","288":"0853e0a8","396":"dadae862","508":"4245aa20","722":"6cc449f3","960":"3f3d93a2"}[chunkId] + ".chunk.css";
};